import React, { useCallback, useRef } from 'react';
import { startOfDay } from 'date-fns';

import useToggle from '@lyearn/core/hooks/useToggle';
import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { BasePopoverContent, Input } from '@lyearn/ui';
import { DatePicker } from '@lyearn/ui';

import { FilterInputProps } from '../types';
import { ANCHOR_ORIGIN, CLASSES, TRANSFORM_ORIGIN } from './styles';

const FilterInputDate = (props: FilterInputProps) => {
  const { value, onChange } = props;
  const [open, { toggle }] = useToggle(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const _onChange = useCallback(
    (date?: Date | null) => {
      if (date && date.toISOString() !== value) {
        onChange(startOfDay(date).toISOString());
      }
    },
    [onChange, value],
  );

  return (
    <>
      <Input
        ref={inputRef}
        readOnly
        className="cursor-pointer"
        placeholder="Select date"
        value={value && Date.parse(value) ? formatDate(new Date(value), DateFormat.Date) : ''}
        onClick={toggle}
      />
      <BasePopoverContent
        anchorEl={inputRef.current}
        anchorOrigin={ANCHOR_ORIGIN}
        classes={CLASSES}
        open={open}
        transformOrigin={TRANSFORM_ORIGIN}
        onClose={toggle}>
        <DatePicker value={value ? new Date(value) : null} onChange={_onChange} />
      </BasePopoverContent>
    </>
  );
};
export default FilterInputDate;
